import { useEffect } from "react";

export const BookDemoPage = () => {
  useEffect(() => {
    // Redirect to the booking URL
    window.location.href = "https://startupfuel.zohobookings.com/#/dgpt";
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to booking page...</p>
      </div>
    </div>
  );
};

